// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__2b4hJ","Label":"BuildControl_Label__2FkzE","Less":"BuildControl_Less__27_-U","More":"BuildControl_More__piZ38"};